module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/16_9.5a026dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/16_9.jpg
// module id = IujW
// module chunks = 0